/**
 * Action for wordpress/media module
 */
import wpAPI from '@/api/wordpress'
import {errorHandler} from '@/helpers'
import types from './types'

const actions = {
  /**
   * メディア一覧の取得
   */
  async [types.FETCH] ({ dispatch, commit, getters, rootGetters }) {
    return wpAPI.getMedia().then(res => {
      commit(types.FETCH, res.data)
      return res.data
    }).catch(errorHandler)
  },

  /**
   * 新規メディアの作成
   */
  async [types.CREATE] ({ dispatch, commit, getters, rootGetters }, option) {
    return wpAPI.createMedia(option.file, {
      headers: {
        'Content-Type': `${option.file.type}`,
        'Content-Disposition': `attachment; filename="${option.file.name}"`
      },
      onUploadProgress: function (e) {
        if (e.total > 0) {
          e.percent = e.loaded / e.total * 100
        }
        option.onProgress(e)
      }
    }).then(res => {
      commit(types.CREATE, res.data)
      return option.onSuccess(res)
    }).catch(err => option.onError(err))
  },

  /**
   * メディアの更新
   */
  async [types.UPDATE] ({ dispatch, commit, getters, rootGetters }, media) {
    return wpAPI.updateMedia(media.id, {
      alt_text: media.alt_text
    }).then(res => {
      commit(types.UPDATE, res.data)
      return res.data
    }).catch(errorHandler)
  },

  /**
   * メディアの削除
   */
  async [types.DELETE] ({ dispatch, commit, getters, rootGetters }, media) {
    return wpAPI.deleteMedia(media.id).then(res => {
      commit(types.DELETE, res.data.previous)
      return res.data.previous
    }).catch(errorHandler)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/media/actions.js